import { GLProgram } from "../program.js";
export class SelectionProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var vertex_source = templates.get('photoshop/GL/shaders/selection/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/selection/fragment.glsl');
        var result = new SelectionProgram(gl, vertex_source, fragment_source);
        return result;
    }

    setUniforms(parameters) {
    }

}